// Vendor
import $ from 'jquery';
//import Helper from 'helpers/util';

// Elements
let $el = $('nav');

class Nav {
	constructor(el) {

		this.mobileMenuOpen = false;

		// Elements
		this.$el = $(el);
		this.$mobileMenuButton = this.$el.find('.nav-mobile-menu-toggle');
		this.$mobileMenu = this.$el.find('.nav-inner');

		// Classes
		this.mobileMenuOpenClass = 'is-open';
		this.mobileMenuOverlayClass = 'nav-mobile-menu-overlay';

		// Init
		// No longer using JS for nav link bg, handled by sass function
		// Helper.pubsub.subscribe('onWindowResize', ()=>{
		// 	this.setupBackground();
		// });
		// $(window).load(()=>{
		// 	this.setupBackground();
		// });

		this.attachEvents();
	}

	attachEvents(){

		//bind nav search dropdown button
		this.$mobileMenuButton.on('click', () => {
			this.toggleMobileMenu();
		});
		//bind nav search toggle to overlay
		$('body').on('click', '.'+this.mobileMenuOverlayClass, () =>{
			this.toggleMobileMenu();
		});

		//scroll for nav shrink/expand
		$(window).scroll(()=>{
			this.navShrinkExpand();
		});
	}

	setupBackground() {

		// set up nav background-position offset
		let $logo = this.$el.find('.nav-logo');
		let $navlinks = this.$el.find('.nav-inner a:not(.nav-logo)');
		let logoWidth = $logo.find('img').width();
		let navWidth = this.$el.find('.nav-inner').width();
		let linkWidth = this.$el.find('.nav-inner a').first().width();

		//set logo anchor width based off logo img width
		// $logo.css({
		// 	width: logoWidth
		// });

		$navlinks.each((i, link) =>{

			if ( $(link).index() > $logo.index() ) {
				// links after logo
				$(link).css({
					backgroundSize: navWidth+'px 200%',
					backgroundPositionX: -(i * linkWidth) - (logoWidth) + 'px'
				});
			} else {
				// links before logo
				$(link).css({
					backgroundSize: navWidth+'px 200%',
					backgroundPositionX: -(i * linkWidth) + 'px'
				});
			}
		});

		this.$el.removeClass('loading');

	}

	navShrinkExpand() {
		let scrollTop = $(document).scrollTop();

		//expand width of nav
		if ( scrollTop > 0 ) {
			this.$el.addClass('scrolled');
		} else {
			this.$el.removeClass('scrolled');
		}

		//shrink/hide top nav
		if ( scrollTop < this.$el.height() || this.previousScrollTop && this.previousScrollTop >= scrollTop ) {
			//scrolled up
			this.$el.removeClass('shift-up');
		} else {
			//scrolled down
			this.$el.addClass('shift-up');
		}

		this.previousScrollTop = scrollTop;
	}

	toggleMobileMenu(){
		if ( !this.mobileMenuOpen ) {
			//open mobile menu
			this.mobileMenuOpen = true;

			//create and fade in overlay
			$('nav').append('<div class="overlay '+this.mobileMenuOverlayClass+'"></div>');
			$('.'+this.mobileMenuOverlayClass).last().fadeIn();

			//toggle mobile menu btn and menu
			this.$mobileMenuButton.addClass(this.mobileMenuOpenClass);
			this.$mobileMenu.addClass(this.mobileMenuOpenClass);
		} else {
			//close mobile bar
			this.mobileMenuOpen = false;

			//fade out and remove overlay
			$('.'+this.mobileMenuOverlayClass).fadeOut(function(){
				$(this).remove();
			});

			//toggle mobile menu btn and menu
			this.$mobileMenuButton.removeClass(this.mobileMenuOpenClass);
			this.$mobileMenu.removeClass(this.mobileMenuOpenClass);
		}
	}

}

export default Nav;

const _init = () => {
	if ($el.length) {
		new Nav($el);
	}
};

_init();
